export default class CCliente {
  codigo: number = 0;
  descricao: string = '';

  constructor(pModel?: Partial<CCliente>) {
    if (!pModel) {
      return;
    }

    this.codigo = pModel.codigo || this.codigo;
    this.descricao = pModel.descricao || this.descricao;
  }
}
